module.exports = __webpack_public_path__ + "static/media/10pulgadas.7409fe94.jpg";